import { forwardRef, useImperativeHandle, useRef } from 'react';
import { cx } from '@chakra-ui/utils';

import { InputControlProps } from '../../../@types';
import { useCountries } from '../../../hooks/useCountries';
import { log } from '../../../utils/logger';

import { SelectControl } from './SelectControl';

export const CountryControl = forwardRef((props: InputControlProps, ref) => {
  const { countryList = [{ name: '', value: '' }] } = useCountries();
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    beforeSubmit() {
      log('CountryControl beforeSubmit does nothing.');
    },
    async validate() {
      await (inputRef.current as any)?.validate();
    },
  }));

  return (
    <SelectControl
      ref={inputRef}
      className={cx('card-form-select-input')}
      // TODO: fix this mess
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      list={countryList}
      {...props}
    />
  );
});
